<template>
  <Qr />
</template>

<script>
import Qr from "../components/namya/Qr_V3.vue";

export default {
  name: "Homes",

  components: {
    Qr,
  },
};
</script>
